/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';

export function customCardSlider() {
  var slider = document.querySelector('.customCardSlider');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'center',
    cellSelector: '.paragraph--type--ln-c-grid-card-item',
    contain: true,
    wrapAround: true,
    pageDots: true,
    prevNextButtons: false,
    watchCSS: true,
    on: {
      ready: function () {
        setTimeout(() => {
          flkty.resize();
        }, 1000);
      }
    }
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.customCardSlider');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }
}

